<div 
  class="responsive-layout-container"
  [class]="layoutClasses.join(' ')"
  [ngStyle]="gridStyle">
  
  <ng-content></ng-content>
  
  <!-- Debug info - only shown in development -->
  <div class="responsive-debug" *ngIf="false">
    <div class="debug-info">
      <small>
        <strong>Screen:</strong> {{ currentScreenSize?.width }}x{{ currentScreenSize?.height }} |
        <strong>Breakpoint:</strong> {{ getCurrentBreakpoint() }} |
        <strong>Columns:</strong> {{ getCurrentColumns() }} |
        <strong>Orientation:</strong> {{ currentScreenSize?.orientation }}
      </small>
    </div>
  </div>
</div>